<template>
  <ion-page @click.stop="" class="modal-primary">
    <img :src="x_icon" class="close-icon" @click="dismiss" />

    <ion-content :force-overscroll="!isWeb">
      <div class="pdf-wrapper" v-if=" resolvedFiles">
        <PdfViewer v-if="resolvedFiles[0] && getViewerType(resolvedFiles[0].type) === 'pdf'" :source="resolvedFiles[0].source"
          :full-size="true" :page="currentPage" @page-changed="handlePageChanged" />
        <VideoViewer v-else-if="resolvedFiles[0] && getViewerType(resolvedFiles[0].type) === 'video'" :source="resolvedFiles[0].source"
          :zoomable="false" />
        <ImageViewer v-else-if="resolvedFiles[0] && getViewerType(resolvedFiles[0].type) === 'image'" :source="resolvedFiles[0].source"
          :zoomable="true" :rotation="rotation" />
        <AudioPlayer v-else-if="resolvedFiles[0] && getViewerType(resolvedFiles[0].type) === 'audio'" :source="resolvedFiles[0].source"
          :type="resolvedFiles[0].type" thumbnail="/assets/Soundwave.svg" :zoomable="false" />
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, toRefs, watch } from "vue";
import { IonContent, modalController, IonPage } from "@ionic/vue";
import { getIcon } from "@/helpers/api";
import { IFile } from "@/modules/a.worksheets/stores/worksheetDataStore";
import PdfViewer from "@/globals/components/PdfViewer/PdfViewer.vue";
import VideoViewer from "@/modules/a.worksheets/views/components/VideoViewer.vue";
import ImageViewer from "@/modules/a.worksheets/views/components/ImageViewer.vue";
import AudioPlayer from "@/modules/a.worksheets/views/components/AudioPlayer.vue";
import { useDeviceStatus } from "@/stores/deviceStatus";
import { getViewerType } from "@/globals/helpers/media/mimeTypeUtils";
import { useWorksheetHandler } from "@/globals/helpers/worksheetHandler";
import { useIFileResolver } from "@/modules/a.worksheets/helpers/useIFileResolver";

const { isWeb, isNetConnected } = toRefs(useDeviceStatus());
const wh = useWorksheetHandler();


const x_icon = ref<string>();
onMounted(async () => {
  x_icon.value = await getIcon("1010", "close");
});
const dismiss = () => modalController.dismiss(null, "close");

const singleExtraArray = computed<IFile[]>(() => {
  const f = wh.wksExtraInfoFile.value; 
  return f ? [f] : [];
});

const { resolve } = useIFileResolver();
const resolvedFiles = resolve(singleExtraArray, { isNetConnected: isNetConnected.value });

const currentPage = ref(1);
function handlePageChanged(page: number) {
  currentPage.value = page;
}

const rotation = ref(0);
function rotate() {
  rotation.value = (rotation.value + 90) % 360;
}


</script>

<style scoped>
.close-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  z-index: 10;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.75);
  padding: 0.25rem;
  border-radius: 50%;
}

.close-icon:hover {
  transform: scale(1.1);
}

.pdf-wrapper {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  padding: 1rem;
  box-sizing: border-box;
}

.no-content-message {
  width: 100%;
  text-align: center;
  margin-top: 2rem;
  color: var(--ion-color-medium);
  font-size: 1rem;
}
</style>
